module.exports = __webpack_public_path__ + "img/0048.520f1301.jpg";